module.exports = "<div class=\"document\" *ngIf=\"details && details.name\" (click)=\"openDocument()\">\r\n  <i *ngIf=\"details.icon\" class=\"fa fa-2x {{ details.icon }}\"></i>\r\n  <span class=\"document-name\" *ngIf=\"!isRequestingDownload\">{{ details.name }}</span>\r\n  <span class=\"document-name\" *ngIf=\"isRequestingDownload\">Downloading...</span>\r\n  <i class=\"fa fa-download fa-2x pull-right\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/communication/document-download/document-download.component.html
// module id = ../../../../../src/app/communication/document-download/document-download.component.html
// module chunks = main